import { useQuery } from '@tanstack/react-query';
import getStrippedDatasetsFn from '../functions/getStrippedDatasetsFn';

const useStrippedDatasets = () => {
  const {
    account: { id: organizationId },
    project: { id: projectId },
  } = window.VSS.getWebContext();

  return useQuery({
    queryFn: getStrippedDatasetsFn,
    queryKey: [`datasets-recent-${organizationId}-${projectId}`],
    enabled: !!organizationId,
    staleTime: Infinity,
  });
};

export default useStrippedDatasets;
